import { Range as RangeCmp } from 'react-range';

import { Content, Thumb, Track } from './range.styled';

export const Range = (props) => {
  const { value, onChange, max, min = 0, step = 1, ...rest } = props;

  const change = (values) => {
    onChange(values[0]);
  };

  return (
    <Content>
      <RangeCmp
        values={[value]}
        min={min}
        max={max}
        step={step}
        onChange={change}
        {...rest}
        renderTrack={({ props, children }) => (
          <Track {...props} style={{ ...props.style }}>
            {children}
          </Track>
        )}
        renderThumb={({ props }) => (
          <Thumb
            {...props}
            key={props.key}
            style={{
              ...props.style,
            }}
          />
        )}
      />
    </Content>
  );
};
